import noop from "lodash/noop";

// on web, "minimum version" enforcement does not apply
// end-users are not in control of web's deployed version
const useShowUpdateAlert = noop;

export default useShowUpdateAlert;
